'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoLaptop = function IoLaptop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.5 8.3v20.5h-35v-20.5c0-0.5 0.3-0.8 0.8-0.8h33.4c0.5 0 0.8 0.3 0.8 0.8z m-2.5 18v-16.3h-30v16.3h30z m-35 4.1v-0.4h40v0.4c-5.5 1.6-9.1 2.1-20 2.1s-14.5-0.5-20-2.1z' })
        )
    );
};

exports.default = IoLaptop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/laptop.js
// module id = 2565
// module chunks = 0